import { CashOutModalSchema } from '@/views/account/MyBets/Components/MyBetsCard/components/CashOutModal/styles/CashOutModal.styles';

export const cashOutModalStyles: CashOutModalSchema = {
  modalContent: {
    bg: 'alpha.400',
    borderRadius: 'lg',
    boxShadow:
      '0px 0px 0px 2px #12171E inset, 0px 0px 0px 3px rgba(255, 255, 255, 0.45) inset, 0px 3px 6px 0px rgba(0, 0, 0, 0.35)',
    border: '2px solid',
    borderColor: 'alpha.500',
    sx: {
      '.chakra-modal__close-btn': {
        color: 'alpha.400',
      },
    },
  },
  stackWrapper: {
    bg: 'blackAlpha.500',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
  },
  heading: { color: 'white' },
  moneyValues: {
    color: 'white',
    textTransform: 'uppercase',
  },
  cashedOutText: { color: 'white' },
  cashedOutQuestion: { color: 'white' },
  declineButton: {
    variant: 'outline',
    fontWeight: 'medium',
    lineHeight: 'medium',
  },
  acceptButton: {
    fontWeight: 'medium',
    lineHeight: 'normal',
  },
  doneButton: {},
};
